import io from 'socket.io-client'

import config from '../../config'

export default class OfferBoardSocket {
  constructor (offerBoardId, onUpdate) {
    this.offerBoardId = offerBoardId
    this.onUpdate = onUpdate
    this.socket = null
  }

  connect () {
    if (!this.offerBoardId) {
      return
    }
    this.socket = io(`${config.rootUrl}offer-board`, {
      jsonp: false,
      reconnection: true,
      reconnectionDelay: 500,
      reconnectionDelayMax: 2500,
      transports: ['websocket']
    })

    const join = () => {
      this.socket.emit('login', {}, (err) => {
        if (err) {
          console.log('offer-board socket login error', err)
          return
        }
        this.socket.emit('join-offer-board', { _id: this.offerBoardId }, (joinErr) => {
          if (joinErr) {
            console.log('join-offer-board error', joinErr)
          }
        })
      })
    }

    this.socket.on('connect', join)
    this.socket.on('reconnect', join)
    this.socket.on('offer-update', (data) => {
      if (this.onUpdate) {
        this.onUpdate(data)
      }
    })
  }

  disconnect () {
    if (this.socket) {
      this.socket.emit('leave-offer-board', { _id: this.offerBoardId }, () => {})
      this.socket.close()
      this.socket = null
    }
  }
}
